import { Combobox } from "./Combobox";
import { IComboboxConfig } from "./types";
import { ProList } from "@dhx/ts-list";
import { ProLayout } from "@dhx/ts-layout";
import { selectAllView } from "./helper";

export class ProCombobox extends Combobox {
	constructor(element: HTMLElement | string, config: IComboboxConfig) {
		super(element, config);
	}

	protected _createLayout() {
		const list = (this.list = new ProList(null, {
			template: this.config.template,
			htmlEnable: this.config.htmlEnable,
			virtual: this.config.virtual,
			keyNavigation: false,
			multiselection: this.config.multiselection,
			itemHeight: this.config.itemHeight,
			height: this.config.listHeight,
			data: this.data,
		}));

		const layout = (this._layout = new ProLayout(this.popup.getContainer(), {
			css: "dhx_combobox-options dhx_combobox__options",
			rows: [
				{
					id: "select-unselect-all",
					hidden: !this.config.multiselection || !this.config.selectAllButton,
				},
				{ id: "list", height: "content" },
				{
					id: "not-found",
					hidden: true,
				},
			],
			on: {
				click: {
					".dhx_combobox__action-select-all": this._handlers.selectAll,
					".dhx_combobox-options__action-create-option": this._handlers.addOption,
				},
			},
		}));

		layout.getCell("list").attach(list);
		if (this.config.multiselection && this.config.selectAllButton) {
			layout.getCell("select-unselect-all").attach(selectAllView);
		}
	}
}
